import { Controller, Toolbar } from '@tencent/workbench';
import { FIXED_KEYS_DOUBLE } from '@src/framework/workbench/schema/constant';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { PictureTabFeature } from './picture-tab-feature';
import { checkChildModelSomeWith } from '@src/framework/frame/components/tool-bar/common/compare-property';
import { isImageOrImageFillShape } from '@src/slide/domain/ui-model/elements/element-judge';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { isPreviewOnly } from '@src/page/toc/common/check-client-vars';

@Controller({
})
export class PictureTabController {
    constructor(private readonly feature: PictureTabFeature) {}

    @Toolbar(FIXED_KEYS_DOUBLE.TOOLBAR_PICTURE, 'shouldHide')
    public shouldHide() {
        const model = this.feature.getSelectModel();
        if (!model || isPreviewOnly()) return true;
        if (isImageOrImageFillShape(model as IElementBaseModel)) {
            return false;
        }
        if (model.type === UIModelType.MULTIPLY || model.type === UIModelType.GROUP) {
            return !checkChildModelSomeWith(model, isImageOrImageFillShape);
        }
        return true;
    }
}
